import ViewHippoInformationModal from '../../../../shared_components/ViewHippoInformationModal/ViewHippoInformationModal';
import type { TableInformation } from '../../../../config/flavourConfig';
import type { YouthContentOnsaDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/onsa/content';

const getYoungPRCInsuranceSumsConfig = (
    contentCoverable: YouthContentOnsaDTO,
    getHippoText: (resourceKey: string) => string
): TableInformation => {
    return {
        title: '',
        rowsInformation: [
            {
                name: getHippoText('DSS-COVERABLE-INFORMATION-STEP-SUMS-CONTENT'),
                fieldValue: `Samlet værdi højst ${contentCoverable.homeYouthContentSum ?? ''}`,
                labelType: 'modalLink',
                modalInformation: {
                    modalType: ViewHippoInformationModal,
                    modalProps: {
                        title: 'DSS-CON-YOUTH-HIGHLIGHTED-TEXT-MODAL-CONTENT-TITLE',
                        description:
                            'DSS-CON-YOUTH-HIGHLIGHTED-TEXT-MODAL-OTHER-CONTENT-DESCRIPTION'
                    }
                }
            },
            {
                name: getHippoText('DSS-COVERABLE-INFORMATION-STEP-SUMS-GOLD-SILVER-JEWELRY'),
                fieldValue: `Samlet værdi højst ${contentCoverable.homeYouthValuables ?? ''}`,
                labelType: 'modalLink',
                modalInformation: {
                    modalType: ViewHippoInformationModal,
                    modalProps: {
                        title: 'DSS-CON-YOUTH-HIGHLIGHTED-TEXT-MODAL-GOLD-SILVER-JEWELRY-TITLE',
                        description:
                            'DSS-CON-YOUTH-HIGHLIGHTED-TEXT-MODAL-GOLD-SILVER-JEWELRY-DESCRIPTION'
                    }
                }
            }
        ]
    };
};

export { getYoungPRCInsuranceSumsConfig };
